import customAxios from "./axiosConfig";

const NirvanaService = {
  getCurrent (params) {
    const api_url = '/api/v2/nirvana/'
    return customAxios.get(api_url, { params: params });
  }
};

export default NirvanaService;